import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { MetricsDisplayGridRowDataFragmentGql } from './MetricsDisplayGridRowDataFragmentGql';

export const WorkbookDownstreamMetricsQueryGql: DocumentNode = gql`
query WorkbookDownstreamMetricsQuery($workbookVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  workbooks(filter: { vizportalUrlId: $workbookVizportalUrlId }) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowDataFragment
      }
    }
  }
}
${MetricsDisplayGridRowDataFragmentGql}
`;
